import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AddNewModal({
  title,
  setTitle,
  modalShow,
  formSubmissionApi,
  show,
  onHide,
}) {
  // Determine open state:
  // If a `show` boolean was provided (preferred), use it.
  // Otherwise assume parent conditionally renders this component and open it.
  const open = typeof show === "boolean" ? show : true;

  // Close handler: prefer onHide, otherwise call modalShow(false) if provided
  const handleClose = () => {
    if (typeof onHide === "function") return onHide();
    if (typeof modalShow === "function") return modalShow(false);
    return null;
  };

  const handleSave = async () => {
    // Basic trim before submission
    if (typeof setTitle === "function") setTitle((t) => (t || "").trim());
    if (typeof formSubmissionApi === "function") {
      await formSubmissionApi();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      // Raise z-index so it appears above other dialogs/modals
      PaperProps={{
        sx: (theme) => ({
          zIndex: theme.zIndex.modal + 2000,
        }),
      }}
      BackdropProps={{
        sx: (theme) => ({
          zIndex: theme.zIndex.modal + 1999,
        }),
      }}
      aria-labelledby="add-new-dialog-title"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <DialogTitle id="add-new-dialog-title">Add New Type</DialogTitle>
        <IconButton aria-label="close" onClick={handleClose} sx={{ mr: 1 }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent dividers>
        <TextField
          autoFocus
          margin="dense"
          label="Title"
          type="text"
          fullWidth
          value={title || ""}
          onChange={(e) => setTitle && setTitle(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </DialogContent>

      <DialogActions sx={{ pr: 2, pb: 2 }}>
        <Button onClick={handleClose} disabled={false}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!(title && title.toString().trim().length > 0)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
